module.exports = __webpack_public_path__ + "static/media/right-ico3.337cc177.svg";